export default "__VITE_ASSET__1vy0dO6___"